/*
 * @description: 接口请求模块
 * client模块对应的分装绑定了this，导致不能使用引用方式调用，只能直接client.xxx才生效
 * @author: Symbol (quxinbo@baidu.com)
 * @createTime: 2024-12-04 12:20:44
 * @LastEditors: Please set LastEditors
 */

import * as PersonTypes from '@/types/api/person';
import * as CompanyTypes from '@/types/api/company';
import type {HttpConfig} from '@/types/http';
import client from './client';

// 实名模糊搜索学校
export const searchUniversity = (university: string, config?: HttpConfig) =>
    client.get('/api/qualify/v3/student/university/search', {university}, config);

// 学生认证校验
export const checkEduAuth = (config?: HttpConfig) =>
    client.post('/api/qualify/v3/student/auth/check', null, config);

// 学生认证提交
export const submitEduAuth = (params: PersonTypes.StudentSubmitParams, config?: HttpConfig) =>
    client.post<PersonTypes.StudentInfoResult>('/api/qualify/v3/student/auth/submit', params, config);

// 学生验证码邮箱发送
export const sendEduAuthCode = (eduEmail: string, config?: HttpConfig) =>
    client.post('/api/qualify/v3/student/verification/code/send', {eduEmail}, config);

// 获取学校认证基本信息
export const getEduAutoInfo = (config?: HttpConfig) =>
    client.get<PersonTypes.StudentInfoResult>('/api/qualify/v3/student/info', null, config);

// 校验是否超出了白名单限制
export const validateQuota = (params: {bizId: string, realNameType: 'PERSONAL' | 'ENTERPRISE'}) =>
    client.post<boolean>('/api/qualify/v3/quota/limit/query', params, {silent: true});

// 获取企业变更原实体信息
export const compChangeOriginQuery = () =>
    client.compChangeOriginQuery();

// 非工商变更二期
export const submitAbnormalChange = (params: CompanyTypes.AbnormalChangeParams, config?: HttpConfig) =>
    client.post<{verifyToken: string}>('/api/qualify/v3/corporation/real/change/abnormal/info/submit', params, config);
